export default __webpack_public_path__ + "static/media/katieKozmaDesktop.23de55d9.jpg";